import type { Category } from "../Category.js";
import { Locale } from "../Locale.js";
import type { ProductForCustomer, ProductInput } from "../Product.js";
import { namesOfFiltrationLabels } from "../namesOfFiltrationLabels.js";

export function isThemedCake(product: ProductInput | ProductForCustomer, cakeCategory: Category | undefined): boolean {
	if (!cakeCategory || !product.categoryIds.includes(cakeCategory.id)) {
		return false;
	}
	return product.filtrationLabels[Locale.cs].includes(namesOfFiltrationLabels.themedCakes[Locale.cs]);
}
